import React from 'react';
import { QuestRoute } from '../../../api/QuestRoutes';
import { addSpacesToPascalCase, generateId, shortHandDateTime } from '../../../utility/functions';
import Table from '../../../table/Table';
import LinkTo from '../../../forms/LinkTo';

const Transactions = ({ ...props }) => {

    const tableConfig = {
        endpoint: QuestRoute.reports.transactions,
        isReport: true,
        headers: [
            {
                label: 'Date Time',
                propKey: 'kioskDateTime',
                type: 'dateTime'
            }, {
                label: 'Type',
                propKey: 'transactionType',
                options: true
            }, {
                label: 'Payment',
                propKey: 'paymentType',
                options: true
            }, {
                label: 'Location',
                propKey: 'locationName',
                options: true
            }, {
                label: 'Model',
                propKey: 'model',
                options: true
            }, {
                label: 'Terminal Name',
                propKey: 'terminalName',
                options: true
            }, {
                label: 'Terminal ID',
                propKey: 'terminalId',
                options: true
            }, {
                label: 'Kiosk Record ID',
                propKey: 'transId',
            }, {
                label: 'Transaction ID',
                propKey: 'id',
            }, {
                label: 'Card Number',
                propKey: 'cardNum',
            }
        ],
        quickSort: [
            {
                label: 'Sales',
                propKey: 'transactionType',
                query: 'Sale',
                color: '#21D59B'
            }, {
                label: 'Refunds',
                propKey: 'transactionType',
                query: 'Refund',
                color: '#96c953'
            }, {
                label: 'Change',
                propKey: 'transactionType',
                query: 'Change',
                color: '#b493e0'
            },
        ],
        renderFormat: (e) => (
            <tr key={generateId()}>
                <td>{shortHandDateTime(e.kioskDateTime)}</td>
                <td>{e.transactionType}</td>
                <td>{addSpacesToPascalCase(e.paymentType)}</td>
                <td>{e.locationName}</td>
                <td>{e.model}</td>
                <td>{e.terminalName}</td>
                <td>{e.terminalId}</td>
                <td>{e.transId}</td>
                <td>
                    <LinkTo
                        target='_blank'
                        to={'/reporting/sales/transaction/' + e.id}
                    >
                        {e.id}
                    </LinkTo>
                </td>
                <td>{e.cardNum}</td>
            </tr>
        )
    }

    return (
        <Table config={tableConfig} />
    );
}

export default Transactions;